export default function getRandomNumbers(count) {
  let result = '';
  for (let i = 0; i < count; i++) {
    result += Math.round(Math.random() * 9);
  }

  return result;
}
